/* eslint-disable no-unused-vars */
import React, { ReactNode } from 'react';
import style from './searchLineContainer.module.scss';
import cx from 'classnames';
import { useSpring, animated } from 'react-spring';
import { DURATIONS } from 'utils/utils';

export default function SearchInputContainer({
  isOpen,
  children,
}: {
  isOpen: boolean;
  children: ReactNode;
}) {
  const anime = useSpring({
    immediate: true,
    delay: isOpen ? 0 : DURATIONS.SEARCH,
    borderBottomLeftRadius: isOpen ? '0px' : '5px',
  });

  return (
    <animated.div
      style={anime}
      className={cx(style.container, 'inputContainer')}
    >
      {children}
    </animated.div>
  );
}
